const styles = {
  alignMiddle: {
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'center',
  },
};

export default styles;
